// src/App.js
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import Login from "./MainLayout/Login";
import Dashboard from './Screens/Dashboard';
import CreateMain from "./Screens/CreationPromo/CreateMain";

function App() {
  return (
    <BrowserRouter>
      <Routes>
        {/* landing → login */}
        <Route path="/" element={<Navigate to="/login" replace />} />

        {/* login page */}
        <Route path="/login" element={<Login />} />

        {/* after login you call nav('/dashboard') */}
        <Route path="/promodashboard/*" element={<Dashboard />} />

        {/* create page */}
        <Route path="/create" element={<CreateMain />} />

        {/* any unknown path → login */}
        <Route path="*" element={<Navigate to="/login" replace />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
